import { useAuth } from '@/hooks/useAuth';
import { useAuthStore } from '@/store/authStore';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());
  const { hasOwnerRole, isFutureOwner } = useAuth();
  const location = useLocation();
  const isReadOnly = location.state?.isReadOnly || false;

  if (!isAuthenticated && location.pathname === '/login') {
    return <>{children}</>;
  }

  if (isAuthenticated && location.pathname === '/login') {
    return <Navigate to="/" replace />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (location.pathname === '/clubs/create' && !isReadOnly && !hasOwnerRole && !isFutureOwner) {
    return <Navigate to="/clubs" replace />;
  }

  return <>{children}</>;
};
